import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    downtimeSummaryWrapper: {
        position: "relative",
        marginTop: 16,
        padding: "0 24px 24px 24px",
        width: "100%",
    },
    card: {
        background: `${theme.palette.primary.main} !important`,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15) !important",
        borderRadius: "4px !important",
        "&::before": {
            content: "none !important",
        },
        "& .Mui-expanded": {
            minHeight: "0 !important",
        },
    },
    cardHeader: {
        padding: "12px 22px !important",
        display: "flex !important",
        borderBottom: `1px solid ${theme.palette.border.select} !important`,
        "& .MuiAccordionSummary-content": {
            alignItems: "center !important",
            margin: "0 !important",
            gap: 8,
        },
    },
    arrow: {
        position: "absolute",
        content: "''",
        top: -16,
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "0 16px 16px 16px",
        borderColor: `transparent transparent ${theme.palette.graphs.main} transparent`,
    },
    downtimeSummaryBody: {
        background: theme.palette.graphs.main,
        height: "100%",
    },
    itemSeparator: {
        display: "flex",
        justifyContent: "center",
        gap: 14,
        "& > svg": {
            marginTop: 36,
            color: theme.palette.info.main,
        },
    },
    cardTitle: {
        fontSize: 18,
        fontWeight: 400,
        fontFamily: "Open Sans",
        color: theme.palette.info.main,
    },
    cardBody: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    cardBodyContent: {
        padding: "14px 14px 4px 14px",
        display: "flex",
        flexWrap: "wrap",
        gap: 14,
    },
    cardHeaderIcon: {
        transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    },
    dotsWrapper: {
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 16,
        bottom: 30,
        left: "50%",
        transform: "translateX(-50%)",
        cursor: "pointer",
    },
    dots: {
        width: 8,
        height: 8,
        borderRadius: "50%",
    },
    dotActive: {
        background: theme.palette.info.main,
    },
    dotInactive: {
        background: theme.palette.graphs.dots,
    },
    arrowLeftButton: {
        position: "absolute !important" as any,
        color: `${theme.palette.primary.dark} !important`,
        bottom: "50%",
        left: 30,
        width: "32px !important",
        height: "32px !important",
        "& svg": {
            fontSize: 32,
            width: "32px !important",
            height: "32px !important",
        },
    },
    arrowRightButton: {
        position: "absolute !important" as any,
        color: `${theme.palette.primary.dark} !important`,
        bottom: "50%",
        right: 30,
        width: "32px !important",
        height: "32px !important",
        "& svg": {
            fontSize: 32,
            width: "32px !important",
            height: "32px !important",
        },
    },
}));
